import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

import notesReducer from "./notesSlice";
import globalReducer from "./globalSlice";
import totalReducer from "./totalSlice";
import ssTotalReducer from "./ssTotalSlice";
import itemPogSummaryReducer from "./itemPogSummarySlice";
import { notesApi } from "../services/notesApi";
import { totalApi } from "../services/totalApi";
import { ssTotalApi } from "../services/ssTotalApi";
import { itemPogSummaryApi } from "../services/itemPogSummaryApi";
import storeMigrations from "./migrations";

const globalPersistConfig = {
  key: "global",
  storage,
  version: 7,
  blacklist: ["loading", "notification", "adjQtyError", "prevAdjQty"],
  migrate: createMigrate(storeMigrations, { debug: false }),
  ...(process.env.NODE_ENV === "production" ||
  ["uat", "qa", "prod"].includes(process.env.REACT_APP_ENV)
    ? {
        transforms: [
          encryptTransform({
            secretKey: process.env.REACT_APP_SECRET_KEY,
          }),
        ],
      }
    : {}),
};

export default combineReducers({
  global: persistReducer(globalPersistConfig, globalReducer),
  notes: notesReducer,
  total: totalReducer,
  ssTotal: ssTotalReducer,
  itemPogSummary: itemPogSummaryReducer,

  //Note: Please make sure updating root middleware for below entry as well.
  [notesApi?.reducerPath]: notesApi.reducer,
  [totalApi?.reducerPath]: totalApi.reducer,
  [ssTotalApi?.reducerPath]: ssTotalApi.reducer,
  [itemPogSummaryApi?.reducerPath]: itemPogSummaryApi.reducer,
});
